<template>
    <c-dialog ref="dialog" height="350" width="450" @resolve="editHandle">
        <c-form ref="form" unit-width="100%">
            <c-form-item label="关联用户">
                <c-input name="user_realname" disabled></c-input>
            </c-form-item>
            <c-form-item label="手机号">
                <c-input name="phone" maxlength="50" disabled></c-input>
            </c-form-item>
            <c-form-item label="姓名" required>
                <c-input name="real_name" maxlength="50"></c-input>
            </c-form-item>
            <c-form-item label="身份证" required>
                <c-input name="identity_no" maxlength="50"></c-input>
            </c-form-item>
        </c-form>
    </c-dialog>
</template>

<script>

export default {
    name:'allinpay_member_auth',

    data() {
        return {
            userId:0
        }
    },

    mounted() {
    },

    methods: {
        /*********打开编辑框，初始化**********/
        open(data) {
            this.$refs.form.clear();
            if (data) {
                this.$refs.form.set(data);
                this.userId = data.user_id;
            }
            //填充form表单
            this.$refs.dialog.open({
                title: '个人用户实名认证'
            });
        },
        /*******创建、编辑提交处理方法********/
        editHandle(stop, next) {
            stop();
            this.$refs.form.submit({
                url: '/allinpay/member/auth',
                rule: {
                    real_name: '请输入真实姓名',
                    identity_no: '请输入身份证号',
                },
                dataFormatter: data => {
                    data.client_user_id = this.userId;  //操作用户ID
                    return data;
                },
                success: (data, res) => {
                    next();
                    this.$message({
                        message: '认证成功',  // 提示内容,
                        type: 'success'
                    });
                    this.$emit('resolve');
                },
                fail: (code, data, msg) => {
                    if (code != 200) {
                        this.$confirm({
                            message: msg,
                            buttonName: '我知道了',
                            cancelButton: false,
                            resolve: () => {
                            }
                        })
                        return false;
                    }
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
.smscode {
    display: block;
    margin-top: 9px;
    margin-right: 8px;
    line-height: 20px;
    font-size: 12px;
    color: var(--color-main);

    &.z-dis {
        color: #999;
    }
}
</style>